// File extension utilities for determining file types
export const VIDEO_EXTENSIONS = ['mp4', 'mov', 'avi', 'mkv', 'webm', 'wmv', 'flv', 'm4v', '3gp'];
export const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp', 'svg', 'tiff', 'tif'];

/**
 * Get file extension from filename
 * @param {string} filename - The filename to extract extension from
 * @returns {string} - The file extension in lowercase
 */
export const getFileExtension = (filename) => {
  if (!filename) return '';
  return filename.split('.').pop().toLowerCase();
};

/**
 * Check if file is a video based on extension
 * @param {string} filename - The filename to check
 * @returns {boolean} - True if file is a video
 */
export const isVideoFile = (filename) => {
  const extension = getFileExtension(filename);
  return VIDEO_EXTENSIONS.includes(extension);
};

/**
 * Check if file is an image based on extension
 * @param {string} filename - The filename to check
 * @returns {boolean} - True if file is an image
 */
export const isImageFile = (filename) => {
  const extension = getFileExtension(filename);
  return IMAGE_EXTENSIONS.includes(extension);
};

/**
 * Check if file is a video based on extension (alternative method)
 * @param {File|string} file - File object or filename string
 * @returns {boolean} - True if file is a video
 */
export const isVideoByExtension = (file) => {
  const filename = typeof file === 'string' ? file : file.name;
  return isVideoFile(filename);
};

/**
 * Check if file is an image based on extension (alternative method)
 * @param {File|string} file - File object or filename string
 * @returns {boolean} - True if file is an image
 */
export const isImageByExtension = (file) => {
  const filename = typeof file === 'string' ? file : file.name;
  return isImageFile(filename);
}; 